import * as React from 'react';

import {BulletedList} from '../../bulleted-list/bulleted-list';
import {Body} from '../../typography/body';

import styles from './individual-integration-page.module.css';

type Props = {
    heading: string;
    items: string | React.ReactNode[];
};

export function IntegrationBulletedList(props: Props) {
    return (
        <div className='mt-32'>
            <Body isBold={true} size='large'>
                {props.heading}
            </Body>
            <div>
                <div className={styles['list-style']}>
                    <BulletedList
                        size='normal'
                        // @ts-expect-error
                        bullets={props.items.map((item, index) => {
                            return typeof item === 'string' ? (
                                <Body key={index}>{item}</Body>
                            ) : (
                                item
                            );
                        })}
                        marginBottom={0}
                    />
                </div>
            </div>
        </div>
    );
}
